<template>
    <div class="empty">
        <div class="list-info">
            <i v-if="props.icon" :class="props.icon"></i>
            <span>{{Language.say(props.text)}}</span>
        </div>
    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import Language        from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    text : {
      default : 'global.content.page_not_found',
    },

    icon : {
      default : "fas fa-exclamation-circle",
    }
  })
</script>
